import React from 'react';
import { Link } from 'react-router';
import RetinaImage from 'react-retina-image';
import { Component } from 'ml-component-web';
import Analytics from '../shared/google-analytics/Analytics';

import logo from '../assets/logo_100.png';
import logo2x from '../assets/logo_100@2x.png';
import apple from '../assets/apple_app_store.svg';
import apple2x from '../assets/apple_app_store@2x.svg';
import google from '../assets/google_app_store.png';
import google2x from '../assets/google_app_store@2x.png';
import './footer.css';

export default class Footer extends Component {

    downloadAndroid = () => {
        Analytics.sendEvent({
            ga: {
                category: 'Download',
                action: 'Android',
            },
        });
    }

    downloadApple = () => {
        Analytics.sendEvent({
            ga: {
                category: 'Download',
                action: 'Apple',
            },
        });
    }

    renderComponent() {
        return (
            <footer className="main-footer">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-2">
                            <h2 className="logo">
                                <Link to="/">
                                    <RetinaImage className="logo" src={[logo, logo2x]} alt="MyBabyBio" />
                                </Link>
                            </h2>
                        </div>
                        <div className="col-sm-2">
                            <h5>Get started</h5>
                            <ul>
                                <li><Link to="/">Home</Link></li>
                            </ul>
                            <h5>Support</h5>
                            <ul>
                                <li><Link to="/faq">FAQs</Link></li>
                            </ul>
                            <h5>Information</h5>
                            <ul>
                                <li><Link to="/about">About us</Link></li>
                                <li><Link to="/press">Press</Link></li>
                            </ul>
                        </div>
                        <div className="col-sm-2">
                            <h5>Legals</h5>
                            <ul>
                                <li><Link to="/privacyPolicy">Privacy Policy</Link></li>
                                <li><Link to="/termsOfUse">Terms of Use</Link></li>
                                <li><Link to="/acceptableUsePolicy">Acceptable Use Policy</Link></li>
                                <li><Link to="/cookiePolicy">Cookie Policy</Link></li>
                                <li><Link to="/appPrivacyPolicy">Privacy Policy (App)</Link></li>
                                <li><Link to="/appEULA">EULA (App)</Link></li>
                            </ul>
                        </div>
                        <div className="col-sm-3">
                            <h5>Download</h5>
                            <ul>
                                <li>
                                    <a href="https://itunes.apple.com/gb/app/mybabybio-online-baby-diary/id1171889819?ls=1&mt=8" target="_blank" onClick={this.downloadApple} rel="noopener noreferrer">
                                        <RetinaImage className="download" alt="Download on the App Store" src={[apple, apple2x]} />
                                    </a>
                                </li>
                                <li>
                                    <a href="https://play.google.com/store/apps/details?id=com.mybabybio" target="_blank" onClick={this.downloadAndroid} rel="noopener noreferrer">
                                        <RetinaImage className="download" alt="Get it on Google Play" src={[google, google2x]} />
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-sm-3">
                            <div className="social-networks">
                                <a href="https://facebook.com/mybabybio" target="_blank" rel="noopener noreferrer">
                                    <i className="fa fa-facebook" />
                                </a>
                                <a href="https://twitter.com/mybabybio" target="_blank" rel="noopener noreferrer">
                                    <i className="fa fa-twitter" />
                                </a>
                                <a href="https://instagram.com/mybabybio" target="_blank" rel="noopener noreferrer">
                                    <i className="fa fa-instagram" />
                                </a>
                            </div>
                            <a href="mailto:support@mybabybio.com" className="contact btn btn-default">Contact us</a>
                        </div>
                    </div>
                </div>
                <div className="footer-copyright">
                    <p>&copy; 2016 MyLife.bio Limited </p>
                </div>
            </footer>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/component/Footer.js
 **/